module.exports = __webpack_public_path__ + "static/media/Cardo-Regular.36b134dd.ttf";